import { render } from "./Home.mobile.vue?vue&type=template&id=53d3100a"
import script from "./Home.mobile.vue?vue&type=script&lang=js"
export * from "./Home.mobile.vue?vue&type=script&lang=js"

import "./Home.mobile.vue?vue&type=style&index=0&id=53d3100a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__